import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2, inject } from '@angular/core';
import { TTerminationReason } from '@partners/types';
import { ProfileService } from '../../process';

@Directive({
  selector: '[exitButton]',
  standalone: true
})
export class ExitButtonDirective implements AfterViewInit, OnDestroy {
  @Input()
  exitButton: TTerminationReason;

  get nativeElement(): HTMLElement {
    return this._elementRef.nativeElement;
  }

  private _clickEventRef: () => void;
  private _renderer = inject(Renderer2);
  private _elementRef = inject(ElementRef);
  private _profileService = inject(ProfileService);

  constructor() {}

  ngAfterViewInit(): void {
    this.addClickListener();
  }

  ngOnDestroy(): void {
    this._clickEventRef && this._clickEventRef();
  }

  private addClickListener(): void {
    const button = this.nativeElement.querySelector('button');
    if (!button) {
      return;
    }
    this._clickEventRef = this._renderer.listen(button, 'click', () => {
      this._profileService.terminateProcess(this.exitButton);
    });
  }
}
